import React from 'react';

import { CheckedPrimary, HomeLogoIcon } from '@/assets';
import { formatNumber, largeNumber } from '@/utils';
import { currencyFormatter } from '@/utils/currency';

import type { DataStatistic } from '../../page';

const InfoFarming: React.FC<{
  apr: number;
  statistic: DataStatistic;
}> = ({ apr, statistic }) => {
  const price = statistic?.price || 0;
  const cs = statistic?.cs || 0;
  const totalSupply = statistic?.totalSupply || 0;

  return (
    <div className="rounded-[24px] border-1 border-gray-100 p-6 shadow-[0px_8px_25px_5px_rgba(199,205,231,0.25)]">
      <div className="flex items-center">
        <div className="-ml-[10px] scale-80">
          <HomeLogoIcon />
        </div>
        <CheckedPrimary className="-ml-1" />
        <span className="ml-3 rounded-[32px] bg-gray-100 px-3 py-1 text-[14px] font-semibold text-black">
          AIRI
        </span>
      </div>
      <p className="mt-3 text-[28px] font-bold leading-none text-black lg:text-[22px] sm:!text-[18px]">
        ${price.toFixed(6)}
      </p>
      <div className="my-5 h-[1px] bg-gray-100" />
      <div className="flex flex-wrap">
        <div className="mb-4 w-[50%]">
          <p className="text-[14px] text-gray-500">Market Cap</p>
          <div className="text-[18px] font-semibold text-black sm:text-[16px]">
            ${formatNumber(price * cs, 0, 3, ',', '.')}
          </div>
        </div>
        <div className="mb-4">
          <p className="text-[14px] text-gray-500">Legacy Stake APR</p>
          <div className="text-[18px] font-semibold text-black sm:text-[16px]">
            {currencyFormatter(apr, { divisor: 0.01, significantDigits: 2 })}%
          </div>
        </div>
      </div>
      <div className="flex flex-wrap">
        <div className="mb-4 w-[50%]">
          <p className="text-[14px] text-gray-500">Amount CS - Max Supply</p>
          <div className="text-[18px] font-semibold text-black sm:text-[16px]">
            {largeNumber(cs, false)} - {largeNumber(totalSupply, false)}
          </div>
        </div>
        <div className="mb-4">
          <p className="text-[14px] text-gray-500">Lock Stake APR</p>
          <div className="text-[18px] font-semibold text-black sm:text-[16px]">20-30%</div>
        </div>
      </div>
      <div>
        <p className="text-[14px] text-gray-500">Staked - Earned</p>
        <div className="text-[18px] font-semibold text-black sm:text-[16px]">AIRI - AIRI</div>
      </div>
    </div>
  );
};

export default InfoFarming;
